(function () {
  if (customElements.get('ce-animate-image-load') !== undefined) {
    return;
  }

  class AnimateImageLoad extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        imagePlaceholder: '[data-animate-image-load-image-placeholder]',
        image: '[data-animate-image-load-image]',
      };

      this.elements = null;

      this._handleLoad = this._handleLoad.bind(this);
    }

    parsedCallback() {
      this.elements = {
        imagePlaceholder: this.querySelector(this.selectors.imagePlaceholder),
        image: this.querySelector(this.selectors.image),
      };

      if (this.elements.image.complete) {
        this._handleLoad();
      } else {
        this.elements.image.addEventListener('load', this._handleLoad);
      }
    }

    disconnectedCallback() {
      this.elements.image.removeEventListener('load', this._handleLoad);
    }

    _handleLoad() {
      const keyframesImagePlaceholder = [{ opacity: 1 }, { opacity: 0 }];

      const keyframesImage = [{ opacity: 0 }, { opacity: 1 }];

      const optionsImagePlaceholder = {
        delay: 450,
        duration: 100,
        fill: 'both',
      };

      const optionsImage = {
        duration: 500,
        fill: 'both',
      };

      const animationImage = this.elements.image.animate(keyframesImage, optionsImage);
      animationImage.addEventListener('finish', () => {
        try {
          animationImage.commitStyles();
        } catch (error) {
          if (error instanceof DOMException) {
            this.elements.image.style.opacity = '1';
          }
        }

        animationImage.cancel();
      });

      const animationImagePlaceholder = this.elements.imagePlaceholder.animate(keyframesImagePlaceholder, optionsImagePlaceholder);
      animationImagePlaceholder.addEventListener('finish', () => {
        try {
          animationImagePlaceholder.commitStyles();
        } catch (error) {
          if (error instanceof DOMException) {
            this.elements.imagePlaceholder.style.opacity = '0';
          }
        }

        animationImagePlaceholder.cancel();
      });
    }
  }

  customElements.define('ce-animate-image-load', AnimateImageLoad);
})();
